import { render, staticRenderFns } from "./NotificationWalletShareInvite.vue?vue&type=template&id=231662f7&scoped=true"
import script from "./NotificationWalletShareInvite.vue?vue&type=script&lang=js"
export * from "./NotificationWalletShareInvite.vue?vue&type=script&lang=js"
import style0 from "./NotificationWalletShareInvite.vue?vue&type=style&index=0&id=231662f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231662f7",
  null
  
)

export default component.exports